export interface Movimentacao {
  id: number;
  incorporadora: Incorporadora;
  empreendimento: Empreendimento;
  tipo_movimentacao: TipoMovimentacaoEnum;
  quantidade?: number;
  ano_movimentacao?: number;
  mes_movimentacao?: MesMovimentacaoEnum;
  endereco: Endereco;
  padrao_acabamento: PadraoAcabamentoEnum;
  parte_empreendimento: ParteEmpreendimento;
  valor_m2: string;
  fase_empreendimento: FaseEmpreendimentoEnum;
  origem_recurso: OrigemRecursoEnum;
  motivo_distrato?: MotivoDistratoEnum;
  was_lancamento: boolean;
  created: string;
  modified: string;
}

export interface MovimentacaoCreate {
  tipo_movimentacao: TipoMovimentacaoEnum;
  quantidade?: number;
  ano_movimentacao?: number;
  mes_movimentacao?: MesMovimentacaoEnum;
  origem_recurso: OrigemRecursoEnum;
  motivo_distrato?: MotivoDistratoEnum;
  was_lancamento: boolean;

  incorporadora?: {
    empresa: number;
  };
  empreendimento?: {
    endereco: number;
    fase_empreendimento: number;
    tipo_empreendimento: string;
    item_empreendimento: string[];
    nome: string;
    quantidade_garagens: number;
    data_entrega: string;
    data_inicio_comercializacao: string;
    observacao: string;
    heading: string;
    pitch: string;
    incorporadora: number;
  };
  endereco?: {
    logradouro: number;
    numero: number;
    complemento: string;
    ponto_referencia: string;
    latitude: string;
    longitude: string;
  };
  parte_empreendimento?: {
    estoque_inicial: number;
    was_lancamento: boolean;
    ano_disponibilidade: number;
    mes_disponibilidade: number;
    origem_recurso: OrigemRecursoEnum;
    tipo_parte_empreendimento: number;
    nome: string;
    area_privativa_m2: string;
    valor_imovel: string;
    forma_pagamento: string;
    atributos_extras: string;
  };
}


export type TipoMovimentacaoEnum = 1 | 2 | 3 | 4;

export const TIPO_MOVIMENTACAO_OPTIONS = [
  { value: 1, label: 'Oferta' },
  { value: 2, label: 'Venda' },
  { value: 3, label: 'Distrato' },
  { value: 4, label: 'Avulso' }
] as const;

export type MesMovimentacaoEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const MES_MOVIMENTACAO_OPTIONS = [
  { value: 1, label: 'Janeiro' },
  { value: 2, label: 'Fevereiro' },
  { value: 3, label: 'Março' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Maio' },
  { value: 6, label: 'Junho' },
  { value: 7, label: 'Julho' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Setembro' },
  { value: 10, label: 'Outubro' },
  { value: 11, label: 'Novembro' },
  { value: 12, label: 'Dezembro' }
] as const;

export type OrigemRecursoEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const ORIGEM_RECURSO_OPTIONS = [
  { value: 1, label: 'Próprio' },
  { value: 2, label: 'SFH' },
  { value: 3, label: 'Condomínio' },
  { value: 4, label: 'Cooperativa' },
  { value: 5, label: 'Próprio+SFH' },
  { value: 6, label: 'OUTROS' },
  { value: 7, label: 'MCMV' }
] as const;

export type MotivoDistratoEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export const MOTIVO_DISTRATO_OPTIONS = [
  { value: 1, label: 'Troca de unidade' },
  { value: 2, label: 'Negativa de crédito' },
  { value: 3, label: 'Troca de empreendimento' },
  { value: 4, label: 'Diminuição de Renda' },
  { value: 5, label: 'Transferência de cidade' },
  { value: 6, label: 'Problema Familiar' },
  { value: 7, label: 'Perda de Interesse' },
  { value: 8, label: 'Desemprego' },
  { value: 9, label: 'Outros' }
] as const;

export type PadraoAcabamentoEnum = 1 | 2 | 3;

export const PADRAO_ACABAMENTO_OPTIONS = [
  { value: 1, label: 'Alto' },
  { value: 2, label: 'Médio' },
  { value: 3, label: 'Baixo' }
] as const;

// Antes ia até 5 (Planta/Fundação/Estrutura/Acabamento/Pronto), mas o backend
// (empreendimento.models.FaseEmpreendimento) só tem 3 fases de verdade — ver
// FASE_EMPREENDIMENTO_LABELS/OPTIONS em types/empreendimento.ts, que é a fonte
// única agora. Esses 2 valores nunca chegavam da API de verdade.
export type FaseEmpreendimentoEnum = 1 | 2 | 3;

// Interfaces auxiliares (simplificadas para o contexto)
export interface Incorporadora {
  id: number;
  empresa: number;
  created: string;
  modified: string;
}

export interface Empreendimento {
  id: number;
  nome: string;
  endereco: Endereco;
  incorporadora: number;
  created: string;
  modified: string;
}

export interface Endereco {
  id: number;
  logradouro: Logradouro;
  numero?: number;
  complemento?: string;
  ponto_referencia?: string;
  latitude: string;
  longitude: string;
  created: string;
  modified: string;
}

export interface Logradouro {
  id: number;
  nome: string;
  bairro: string;
  zipcode: string;
  cidade: Cidade;
  created: string;
  modified: string;
}

export interface Cidade {
  id: number;
  nome: string;
  uf: string;
  estado: string;
  created: string;
  modified: string;
}

export interface ParteEmpreendimento {
  id: number;
  nome: string;
  area_privativa_m2: string;
  valor_imovel: string;
  forma_pagamento: string;
  empreendimento: number;
  created: string;
  modified: string;
} 



// nova movimentacao





// src/types/movimentacao.ts

// 🔹 Enum dos campos que podem ser alterados em Empreendimentos
export enum CamposMovimentacaoEmpreendimento {
  AREA_CONSTRUIDA = 2,
  DATA_ENTREGA = 4,
  DATA_INICIO_COMERCIALIZACAO = 5,
  OBSERVACAO = 6,
  FASE_EMPREENDIMENTO = 7,
  TABELA_PRECO = 8,
  BOOK = 9,
  ARQUIVO_EXTRA_1 = 10,
  ARQUIVO_EXTRA_2 = 11,
}

// 🔹 Enum dos campos que podem ser alterados em Unidades
export enum CamposMovimentacaoUnidade {
  DISPONIBILIDADE = 1,
  VALOR = 2,
  FORMA_PAGAMENTO = 3,
}

// 🔹 Tipo genérico para o usuário que fez a movimentação
export interface UsuarioResumo {
  id: number;
  username: string;
}

// 🔹 Movimentação de Empreendimento (retorno da API)
export interface MovimentacaoEmpreendimento {
  id: number;
  empreendimento: number; // ID do empreendimento
  usuario: number; // ID do usuário
  usuario_nome: string;
  campo_alterado: CamposMovimentacaoEmpreendimento;
  campo_alterado_display: string;
  valor_antigo: string;
  valor_novo: string;
  data_hora: string; // ISO string
  tabela_preco?: string | null;
  book?: string | null;
  arquivo_extra_1?: string | null;
  arquivo_extra_2?: string | null;
}

// 🔹 Movimentação de Unidade (retorno da API)
export interface MovimentacaoUnidade {
  id: number;
  unidade: number; // ID da unidade
  usuario: number; // ID do usuário
  usuario_nome: string;
  campo_alterado: CamposMovimentacaoUnidade;
  campo_alterado_display: string;
  valor_antigo: string;
  valor_novo: string;
  data_hora: string; // ISO string
}

// 🔹 Payload para criar movimentação de empreendimento
export interface MovimentacaoEmpreendimentoCreate {
  empreendimento: number; // só o ID
  campo_alterado: CamposMovimentacaoEmpreendimento;
  valor_antigo: string;
  valor_novo: string;
  tabela_preco?: File;
  book?: File;
  arquivo_extra_1?: File;
  arquivo_extra_2?: File;
}

// 🔹 Payload para criar movimentação de unidade
export interface MovimentacaoUnidadeCreate {
  unidade: number; // só o ID
  campo_alterado: CamposMovimentacaoUnidade;
  valor_antigo: string;
  valor_novo: string;
}

// src/types/snapshots.ts

// 🔹 Snapshot de Empreendimento (retorno da API)
export interface SnapshotEmpreendimento {
  id: number;
  data_snapshot: string; // ISO string
  area_construida: number;
  data_entrega: string; // ISO string
  data_inicio_comercializacao: string; // ISO string
  observacao: string;
  fase_empreendimento: number;
  empreendimento: number; // ID do empreendimento
  tabela_preco?: string; // Added this line
  book?: string | null;
  arquivo_extra_1?: string | null;
  arquivo_extra_2?: string | null;
  movimentacoes?: MovimentacaoEmpreendimento[]
}

// 🔹 Snapshot de Unidade (retorno da API)
export interface SnapshotUnidade {
  id: number;
  data_snapshot: string; // ISO string
  disponibilidade: number;
  valor_imovel: string;
  forma_pagamento: string;
  unidade: number; // ID da unidade
  movimentacoes?: MovimentacaoEmpreendimento[]
}

// 🔹 Query params opcionais para filtros (GET)
export interface SnapshotUnidadeQueryParams {
  unidade?: number;
  empreendimento?: number;
  data_snapshot?: string;
  limit?: number;
  offset?: number;
}

export interface SnapshotEmpreendimentoQueryParams {
  empreendimento?: number;
  ordering?: string;
  limit?: number;
  offset?: number;
}

// 🔹 Payload para a API unificada (apenas JSON)
export interface UnifiedMovimentacaoPayload {
  movimentacoes_empreendimento?: MovimentacaoEmpreendimentoCreate[];
  movimentacoes_unidade?: MovimentacaoUnidadeCreate[];
}

// 🔹 Estrutura completa para criação de movimentação unificada (incluindo arquivos)
export interface UnifiedMovimentacaoCreate extends UnifiedMovimentacaoPayload {
  empreendimento_files?: File[];
  unidade_files?: File[];
}
